var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v("功能")]),_c('ul',[_c('li',{class:{ active: _vm.isactive == 1 },on:{"click":_vm.jumpE}},[_vm._v("报名")]),_c('li',{class:{ active: _vm.isactive == 2 },on:{"click":_vm.jumpA}},[_vm._v("查成绩")])])])}
var staticRenderFns = []

export { render, staticRenderFns }